import React from 'react';

class Calendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMonths: [],
      m_count: 0,
      selectedYear: '',
      selectedTerms: {
        2019: []
      },
      navYear: 2019
    }
  }
  onClickYearPrev () {
    if (this.state.navYear > 2019) {
      let s = this.state.selectedTerms
      if (!s[this.state.navYear-1]) {
        s[this.state.navYear-1] = [];
        this.setState({
          selectedTerms: s,
          navYear: this.state.navYear-1
        });
      } else {
        this.setState({
          navYear: this.state.navYear-1
        });
      }
    }
  }
  onClickYearNext () {
    let s = this.state.selectedTerms
    if (!s[this.state.navYear+1]) {
      s[this.state.navYear+1] = [];
      this.setState({
        selectedTerms: s,
        navYear: this.state.navYear+1
      });
    } else {
      this.setState({
        navYear: this.state.navYear+1
      });
    }
  }
  onSelectMonth (m) {
    let s = this.state.selectedTerms;
    if (s[this.state.navYear].indexOf(m) < 0) {
      s[this.state.navYear].push(m)
      this.setState({selectedTerms: s, m_count: this.state.m_count+1})
      this.props.toggleRequestBtn(false)
    } else {
      s[this.state.navYear] = s[this.state.navYear].filter(x => x != m);
      this.setState({selectedMonths: s, m_count: this.state.m_count-1})
      if (this.state.m_count-1 == 0) {
        this.props.toggleRequestBtn(true)
      }
    }
    console.log(this.state.m_count)
  }
    renderMonthA () {
      return (
        ['Jan', 'Feb', 'Mar', 'Apr'].map((m, i) => {
          let selected = this.state.selectedTerms[this.state.navYear];
          let isSelected = selected.indexOf(m) >= 0
          return (<td className={`cal-item${isSelected ? 
            ' cal-item-selected' : ''}`} key={i}
            onClick={this.onSelectMonth.bind(this, m)}>{m}</td>)})
      )
  }
  renderMonthB () {
    return (
      ['May', 'Jun', 'Jul', 'Aug'].map((m, i) => {
        let selected = this.state.selectedTerms[this.state.navYear];
        let isSelected = selected.indexOf(m) >= 0
        return (<td className={`cal-item${isSelected ? 
          ' cal-item-selected' : ''}`} key={i}
          onClick={this.onSelectMonth.bind(this, m)}>{m}</td>)})
    )
  }
  renderMonthC () {
    return (
      ['Sep', 'Oct', 'Nov', 'Dec'].map((m, i) => {          
        let selected = this.state.selectedTerms[this.state.navYear];
        let isSelected = selected.indexOf(m) >= 0
        return (<td className={`cal-item${isSelected ? 
          ' cal-item-selected' : ''}`} key={i}
          onClick={this.onSelectMonth.bind(this, m)}>{m}</td>)})
    )
  }
  
  render () {
    let price = this.props.price ? this.props.price : 0;
    let m_count = 0;
    let s = this.state.selectedTerms;
    Object.keys(s).forEach((t, i) => {
      m_count = s[t].length + m_count; 
    })
    return (
      <div className="cal-container">
        <div className="cal-year d-flex">
          <div className={`cal-year-nav-prev${this.state.navYear == 2019 ? ' cal-year-nav-disable' : ''}`} 
            onClick={this.onClickYearPrev.bind(this)}>
            <i className="fas fa-caret-left fa-lg"></i>
          </div>
          <div className="cal-year-current">{this.state.navYear}</div>
          <div className="cal-year-nav-next"
            onClick={this.onClickYearNext.bind(this)}>
            <i className="fas fa-caret-right fa-lg"></i>
          </div>
        </div>
        <table className="cal-table">
          <tbody>
            <tr className="cal-row">
              {this.renderMonthA()}
            </tr>
            <tr className="cal-row">
              {this.renderMonthB()}
            </tr>
            <tr className="cal-row">
              {this.renderMonthC()}
            </tr>
          </tbody>
        </table>

        {m_count > 0 ? <div className="cal-total">
          <div className="cal-total-item flex-space-between">
            <div className="cal-total-item-label">Rent</div>
            <div className="cal-total-item-price">$ {price*m_count}</div>
          </div>
          <div className="cal-total-item cal-total-item-minor flex-space-between ">
            <div className="cal-total-item-label-minor">({`$${price} x ${m_count} months`})</div>
          </div>
          <div className="cal-total-item flex-space-between cal-total-item-final">
            <div className="cal-total-item-label">Total</div>
            <div className="cal-total-item-price">$ {price*m_count}</div>
          </div>
        </div> : null}
      </div>
      )
  }
}

export default Calendar;